<template>
  <div class="component" v-if="homeProductInfo">
    <el-row class="top-row">
      <el-col :span="24" :offset="0">
        <div class="flex-container">
          <div class="flex-item primary-clickable-thumbnail clickable-thumbnail"
            :style="{ backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.05) 0%, rgb(0, 0, 0, 0.6) 100%), url(' + mainVideoImageURL + ')' }"
            v-if="!primaryVideoSelected" v-on:click="primaryVideoSelected = !primaryVideoSelected">
            <div class="primary-thumbnail-container">
              <div class="primary-thumbnail-copy">
                <h3>{{ homeProductInfo.productInformationMainVideoHeadline }}</h3>
                <p>{{ homeProductInfo.productInformationMainVideoSubhead }}</p>
              </div>

              <!-- video icon -->
              <svg class="video-icon" width="37" height="25" viewBox="0 0 37 25" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M35.1167 2.28167C34.6484 2.03151 34.1211 1.91289 33.5908 1.93842C33.0605 1.96395 32.5471 2.13268 32.105 2.42667L26.6667 6.05167V4.19833C26.6653 3.08527 26.2226 2.01818 25.4355 1.23113C24.6485 0.444072 23.5814 0.00132324 22.4683 0H4.19833C3.08527 0.00132324 2.01818 0.444072 1.23112 1.23113C0.444071 2.01818 0.00132324 3.08527 0 4.19833V20.8017C0.00132324 21.9147 0.444071 22.9818 1.23112 23.7689C2.01818 24.5559 3.08527 24.9987 4.19833 25H22.4683C23.5814 24.9987 24.6485 24.5559 25.4355 23.7689C26.2226 22.9818 26.6653 21.9147 26.6667 20.8017V18.9483L32.105 22.5733C32.547 22.8676 33.0605 23.0365 33.5909 23.062C34.1212 23.0874 34.6486 22.9686 35.1167 22.718C35.5849 22.4674 35.9762 22.0945 36.2492 21.6391C36.5221 21.1836 36.6664 20.6626 36.6667 20.1317V4.86833C36.6663 4.33732 36.522 3.81635 36.249 3.36086C35.9761 2.90537 35.5848 2.5324 35.1167 2.28167ZM23.3333 20.8017C23.3333 21.0311 23.2422 21.2511 23.08 21.4133C22.9178 21.5755 22.6977 21.6667 22.4683 21.6667H4.19833C3.96892 21.6667 3.74891 21.5755 3.58669 21.4133C3.42447 21.2511 3.33333 21.0311 3.33333 20.8017V4.19833C3.33333 3.96892 3.42447 3.7489 3.58669 3.58669C3.74891 3.42447 3.96892 3.33333 4.19833 3.33333H22.4683C22.6977 3.33333 22.9178 3.42447 23.08 3.58669C23.2422 3.7489 23.3333 3.96892 23.3333 4.19833V20.8017ZM33.3333 19.3867L26.6667 14.9417V10.0583L33.3333 5.61333V19.3867Z"
                  fill="white" />
              </svg>
            </div>

          </div>
          <div v-else class="flex-item">
            <div class="video-wrap">
              <iframe class="video"
                :src="`https://player.vimeo.com/video/${mainVideoIdWithParams}byline=0&title=0&portrait=0&color=e50b19&autoplay=1`"
                frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen webkitallowfullscreen
                mozallowfullscreen>
              </iframe>
            </div>
          </div>
          <div class="flex-item copy-container">
            <div class="copy">
              <div class="header-container">
                <h2>{{ homeProductInfo.productInformationHeadline }}</h2>
              </div>
              <div class="copy-inner-wrap">
                <p>{{ homeProductInfo.productInformationSubhead }}</p>
                <div class="list" v-html="homeProductInfo.productInformationDescription">
                </div>
                <a v-if="homeProductInfo.productInformationCtaLink" :href="homeProductInfo.productInformationCtaLink">
                  <button class="el-button el-button--primary">
                    {{ homeProductInfo.productInformationCtaText }}
                  </button>
                </a>
                <router-link v-else :to="{ name: 'Products' }">
                  <button class="el-button el-button--primary">
                    {{ homeProductInfo.productInformationCtaText }}
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="bottom-row" v-if="secondaryVideoIdWithParams">
      <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 20, offset: 2 }"
        :lg="{ span: 20, offset: 2 }" :xl="{ span: 20, offset: 2 }">
        <div class="clickable-thumbnail"
          :style="{ backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.05) 0%, rgb(0, 0, 0, 0.6) 100%), url(' + secondaryVideoImageURL + ')' }"
          v-if="!secondaryVideoSelected" v-on:click="secondaryVideoSelected = !secondaryVideoSelected">
          <div class="secondary-thumbnail-container">
            <div class="secondary-thumbnail-copy">
              <p>{{ secondaryVideoCategoryTitle }}</p>
              <h3>{{ homeProductInfo.productInformationSecondaryVideoHeadline }}</h3>
            </div>
          </div>
          <svg class="video-icon" width="37" height="25" viewBox="0 0 37 25" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M35.1167 2.28167C34.6484 2.03151 34.1211 1.91289 33.5908 1.93842C33.0605 1.96395 32.5471 2.13268 32.105 2.42667L26.6667 6.05167V4.19833C26.6653 3.08527 26.2226 2.01818 25.4355 1.23113C24.6485 0.444072 23.5814 0.00132324 22.4683 0H4.19833C3.08527 0.00132324 2.01818 0.444072 1.23112 1.23113C0.444071 2.01818 0.00132324 3.08527 0 4.19833V20.8017C0.00132324 21.9147 0.444071 22.9818 1.23112 23.7689C2.01818 24.5559 3.08527 24.9987 4.19833 25H22.4683C23.5814 24.9987 24.6485 24.5559 25.4355 23.7689C26.2226 22.9818 26.6653 21.9147 26.6667 20.8017V18.9483L32.105 22.5733C32.547 22.8676 33.0605 23.0365 33.5909 23.062C34.1212 23.0874 34.6486 22.9686 35.1167 22.718C35.5849 22.4674 35.9762 22.0945 36.2492 21.6391C36.5221 21.1836 36.6664 20.6626 36.6667 20.1317V4.86833C36.6663 4.33732 36.522 3.81635 36.249 3.36086C35.9761 2.90537 35.5848 2.5324 35.1167 2.28167ZM23.3333 20.8017C23.3333 21.0311 23.2422 21.2511 23.08 21.4133C22.9178 21.5755 22.6977 21.6667 22.4683 21.6667H4.19833C3.96892 21.6667 3.74891 21.5755 3.58669 21.4133C3.42447 21.2511 3.33333 21.0311 3.33333 20.8017V4.19833C3.33333 3.96892 3.42447 3.7489 3.58669 3.58669C3.74891 3.42447 3.96892 3.33333 4.19833 3.33333H22.4683C22.6977 3.33333 22.9178 3.42447 23.08 3.58669C23.2422 3.7489 23.3333 3.96892 23.3333 4.19833V20.8017ZM33.3333 19.3867L26.6667 14.9417V10.0583L33.3333 5.61333V19.3867Z"
              fill="white" />
          </svg>
        </div>
        <div v-else>
          <div class="video-wrap">
            <iframe class="video"
              :src="`https://player.vimeo.com/video/${secondaryVideoIdWithParams}byline=0&title=0&portrait=0&color=e50b19&autoplay=1`"
              frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen webkitallowfullscreen
              mozallowfullscreen>
            </iframe>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import home from './';

export default {
  name: 'HomeProductInfo',
  computed: {
    ...mapState(home.store.namespace, [
      'homeProductInfo'
    ]),
    mainVideoImageURL() {
      return this.homeProductInfo?.productInformationMainVideoImage?.[0]?.url || '';
    },
    secondaryVideoImageURL() {
      return this.homeProductInfo?.productInformationSecondaryVideoImage?.[0]?.url || '';
    },
    secondaryVideoCategoryTitle() {
      return this.homeProductInfo?.productInformationSecondaryVideoCategory?.[0]?.title || '';
    },
    mainVideoIdWithParams() {
      return this.parseURL(this.homeProductInfo?.productInformationMainVideoLink);
    },
    secondaryVideoIdWithParams() {
      return this.parseURL(this.homeProductInfo?.productInformationSecondaryVideoLink);
    }
  },
  methods: {
    parseURL(fullURL) {
      if (!fullURL) {
        return ''
      }
      let idWithParamsLocation = fullURL.indexOf('.com/') + 5
      let idWithParams = fullURL.slice(idWithParamsLocation)
      if (idWithParams.includes('?')) {
        idWithParams += '&'
      } else {
        idWithParams += '?'
      }
      return idWithParams
    }
  },
  data() {
    return {
      primaryVideoSelected: false,
      secondaryVideoSelected: false,
    }
  },
}

</script>

<style lang="scss" scoped>
@import 'element-theme-chalk/src/mixins/mixins.scss';
@import '@/assets/base/_variables.scss';

.flex-item {
  width: 50%;

  @include res(sm-and-down, $--breakpoints-spec) {
    width: 100%;
  }
}

.component {
  padding: 100px 0px;
  background-color: $--color-grayscale-1;

  @include res(sm-and-down, $--breakpoints-spec) {
    padding: 50px 0px;
  }
}

:deep(.clickable-thumbnail) {
  background-size: cover;
  background-repeat: no-repeat;
  cursor: pointer;
  position: relative;
  display: flex;

  p,
  h3 {
    color: $--color-white;
  }

  &:hover {
    box-shadow: 0px 8px 50px rgba(0, 0, 0, 0.3);

    p,
    h3 {
      color: $--color-grayscale-3;
    }
  }
}

.primary-thumbnail-container {
  padding: 50% 0 0 0;
}

.secondary-thumbnail-container {
  padding: 30% 0 0 0;
}

.primary-thumbnail-copy {
  padding-left: 30px;
  padding-bottom: 30px;
  padding-right: 30px;

  p {
    margin: 10px 0 0 0;
  }

}

.secondary-thumbnail-copy {
  padding-bottom: 30px;
  padding-left: 30px;
  padding-right: 30px;

  h3 {
    font-size: 25px;
  }

  p {
    text-transform: uppercase;
    margin: 0px 0px 10px 0px;
    font-size: 14px;
    letter-spacing: 0.055em;
  }
}

.video-wrap {
  position: relative;
  padding: 67.5% 0 0 0;
}

.video-icon {
  position: absolute;
  top: 30px;
  right: 30px;
}

.video {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.bottom-row {
  margin-top: 100px;

  @include res(sm-and-down, $--breakpoints-spec) {
    display: none;
  }
}

.flex-container {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;

  @include res(sm-and-down, $--breakpoints-spec) {
    flex-wrap: wrap;
  }
}

.list {
  margin-bottom: 40px;
}

:deep(.copy) {
  padding-left: 70px;
  margin-bottom: 0px;

  @include res(sm-and-down, $--breakpoints-spec) {
    padding-left: 0px;
    margin-bottom: 35px;
  }

  h2 {
    color: $--color-white;
  }

  p {
    color: $--color-secondary;
    text-transform: uppercase;
    font-family: $font-family-headings;
    font-weight: bold;
    font-size: 1.125rem;
  }

  ul {
    list-style: none;
    padding-left: 0;

    li {
      padding-left: 2em;
      padding-top: 0.25em;
      margin-bottom: 0.5em;
      display: block;
      position: relative
    }

    li::before {
      content: '';
      position: absolute;
      left: 0;
      top: 6px;
      width: 20px;
      height: 20px;
      background-repeat: no-repeat;
      background-image: url('@/assets/images/check-blue.svg')
    }

  }

  button {
    padding: 20px 35px;
    font-size: 14px;
  }
}

.header-container {
  background-image: url('@/assets/images/large-rectangle-background.svg');
  background-repeat: no-repeat;
  background-size: cover;
  width: 80%;
  padding: 30px 0px 30px 40px;

  @include res(md-and-down, $--breakpoints-spec) {
    padding: 23px 0px 23px 25px;
    background-size: cover;
    width: 90%;
  }
}

.copy-container {
  @include res(sm-and-down, $--breakpoints-spec) {
    order: -1
  }
}

.primary-clickable-thumbnail {
  /* 1/24 ~= 4.17 */
  margin-right: 4.17vw;
  margin-left: 4.17vw;
}

.copy-inner-wrap {
  @include res(sm-and-down, $--breakpoints-spec) {
    /* 1/24 ~= 4.17 */
    padding-left: 4.17vw;
  }
}
</style>

